// libs
import styled, { css } from 'styled-components'
// static
import CloseIconOrigin from '@mui/icons-material/Cancel'
// themes
import colors from 'themes/colors'
// utils
import { darken, size } from 'polished'

export const CloseIcon = styled(CloseIconOrigin)<any>`
  && {
    min-width: 18px;
    cursor: pointer;
  }

  path {
    fill: ${colors.gray450};
  }

  &:hover {
    path {
      fill: ${darken(0.1, colors.gray450)};
    }
  }

  ${size('18px')};
`

export const LinkWrapper = styled.div`
  align-items: center;
  display: flex;
  min-height: 32px;
  gap: 12px;
`

export const Link = styled.a<{ isDisabled: boolean }>`
  color: ${({ isDisabled }) => (isDisabled ? colors.gray320 : colors.black)};
`

export const DocOrLinkWrapper = styled.div<{ $disabled: boolean; $isForm: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ $isForm }) => ($isForm ? 'center' : 'flex-start')};

  > span {
    font-weight: bold;

    :first-child {
      user-select: none;
    }
  }

  a {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  ${({ $disabled }) =>
    !$disabled &&
    css`
      svg {
        cursor: pointer;

        &:hover {
          color: ${darken(0.07, colors.blue500)};
        }
      }
    `};
`

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
`

